import React from 'react';
import {Modal, Form, Button, Radio} from 'antd';
import StationTableNonAction from './StationTableNonAction';
import StationTableMobileNonAction from './StationTableMobileNonAction';
import {STATION_MANAGEMENT_ROLE, STATION_CONTROL_ROLE, STATION_MONITORING_ROLE} from '../constants/defaultValues'
const FormItem = Form.Item;

class AccountRoleStationModalForm extends React.Component {
  handleSelectedKeys = (selectedKeys) => {
    const {form} = this.props
    form.setFieldsValue({selectedKeys: selectedKeys});
  }

  render() {
    const {
      stations,
      domains,
      role,
      groups,
      fetchingStations,
      fetchingPermissions,
      title,
      visible,
      onCancel,
      onSubmit,
      form,
      isMobile
    } = this.props

    const initialRole = (role === STATION_MANAGEMENT_ROLE || role === STATION_CONTROL_ROLE || role === STATION_MONITORING_ROLE)
      ? role
      : undefined

    const selectedKeys = domains.filter((domain) => {
      const index = stations.findIndex((station) => {
        return station.ID === domain
      })
      return index > -1
    }) || []

    const {getFieldDecorator} = form
    return (<Modal visible={visible} title={title} width={720} okText="Lưu" cancelText="Bỏ qua" onCancel={onCancel} onOk={onSubmit} footer={[
        <Button key="cancel" onClick={onCancel}>Bỏ qua</Button>,
        <Button key="submit" type="primary" ghost="ghost" onClick={onSubmit}>
          Lưu
        </Button>
      ]} className="modal-form">
      <Form layout="vertical">
        <FormItem label="Quyền">
          {
            getFieldDecorator('role', {
              rules: [
                {
                  required: true,
                  message: 'Phải chọn quyền!'
                }
              ],
              initialValue: initialRole
            })(<Radio.Group size="small">
              <Radio.Button value={STATION_MANAGEMENT_ROLE}>Quản lý</Radio.Button>
              <Radio.Button value={STATION_CONTROL_ROLE}>Điều khiển</Radio.Button>
              <Radio.Button value={STATION_MONITORING_ROLE}>Giám sát</Radio.Button>
            </Radio.Group>)
          }
        </FormItem>
        {
          (!fetchingStations && !fetchingPermissions)
            ? <FormItem label="Danh sách trạm">
                {
                  getFieldDecorator('selectedKeys', {
                    rules: [
                      {
                        required: true,
                        message: 'Phải chọn danh sách trạm!'
                      }
                    ],
                    initialValue: selectedKeys
                  })(
                    isMobile
                    ? <StationTableMobileNonAction stations={stations} selectedKeys={selectedKeys} groups={groups} onSelectedKeys={this.handleSelectedKeys} />
                    : <StationTableNonAction stations={stations} selectedKeys={selectedKeys} groups={groups} onSelectedKeys={this.handleSelectedKeys} />)
                }
              </FormItem>
            : null
        }
      </Form>
    </Modal>);
  }
}

export default Form.create()(AccountRoleStationModalForm)



// WEBPACK FOOTER //
// ./src/components/AccountRoleStationModalForm.js